module.exports = __webpack_public_path__ + "static/media/forest_cover.4810624b.png";